import {
  FETCH_GGN_PROPCOMS,
  FETCH_GGN_PROPCOM,
  SEARCH_GGN_PROPCOMS,
  FETCHING_GGN_PROPCOMS,
} from '../actions/types';

const INITIAL_STATE = { 
  city:'', 
  fetching:true,
  fetchingCS:true,
  fetchingCR:true,
  propcomsMy: [],
  propcomsCS: [],
  propcomsCR: [],
  propcom: null, 

  offsetCS: 0, 
  offsetCR: 0,
  offsetCRSH: 0,
  offsetCSSH: 0,   //for shortlist

  limitCS: 20,
  limitCR: 20,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_GGN_PROPCOMS:
      return { ...state, ...action.payload };
    case FETCH_GGN_PROPCOM:
      return { ...state, propcom: action.payload };
    
    case SEARCH_GGN_PROPCOMS:
      
      return { ...state, ...action.payload };
    
    case FETCHING_GGN_PROPCOMS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
